module.exports = __webpack_public_path__ + "assets/20c13dd689379e6147645058157289cc.png";